<script>
import { sanitize } from "@shared/utils/sanitize"
export let content = ""
$: safeContent = sanitize(content)
</script>

<h2 class="h2 {$$props.className || ''}">
  {@html safeContent}
</h2>
